<template>
  <svg viewBox="0 0 129 128" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="52.4965"
      y="88.7064"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 52.4965 88.7064)"
      fill="#080072"
    />
    <rect
      x="50.6675"
      y="13.7175"
      width="9.145"
      height="9.145"
      rx="3.658"
      transform="rotate(180 50.6675 13.7175)"
      fill="#8FDDFF"
    />
    <rect
      x="89.0764"
      y="88.7064"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 89.0764 88.7064)"
      fill="#080072"
    />
    <rect
      x="88.6321"
      y="105.632"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 88.6321 105.632)"
      fill="#13A7FF"
    />
    <rect
      x="106.422"
      y="105.922"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 106.422 105.922)"
      fill="#8FDDFF"
    />
    <rect
      x="52.4965"
      y="70.4165"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 52.4965 70.4165)"
      fill="#13A7FF"
    />
    <rect
      x="89.0764"
      y="70.4165"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 89.0764 70.4165)"
      fill="#13A7FF"
    />
    <rect
      x="70.7865"
      y="88.7064"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 70.7865 88.7064)"
      fill="#13A7FF"
    />
    <rect
      x="68.9575"
      y="13.7175"
      width="9.145"
      height="9.145"
      rx="3.658"
      transform="rotate(180 68.9575 13.7175)"
      fill="#8FDDFF"
    />
    <rect
      x="87.2175"
      y="13.7175"
      width="9.145"
      height="9.145"
      rx="3.658"
      transform="rotate(180 87.2175 13.7175)"
      fill="#8FDDFF"
    />
    <rect
      x="33.292"
      y="87.7919"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 33.292 87.7919)"
      fill="#13A7FF"
    />
    <rect
      x="33.292"
      y="105.922"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 33.292 105.922)"
      fill="#8FDDFF"
    />
    <rect
      x="14.0875"
      y="68.5875"
      width="9.145"
      height="9.145"
      rx="3.658"
      transform="rotate(180 14.0875 68.5875)"
      fill="#8FDDFF"
    />
    <rect
      x="14.0875"
      y="86.7175"
      width="9.145"
      height="9.145"
      rx="3.658"
      transform="rotate(180 14.0875 86.7175)"
      fill="#8FDDFF"
    />
    <rect
      x="71.701"
      y="71.3311"
      width="14.632"
      height="14.632"
      rx="1.4632"
      transform="rotate(180 71.701 71.3311)"
      fill="#080072"
    />
    <rect
      x="107.366"
      y="70.4165"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 107.366 70.4165)"
      fill="#13A7FF"
    />
    <rect
      x="123.798"
      y="68.5875"
      width="9.145"
      height="9.145"
      rx="3.658"
      transform="rotate(180 123.798 68.5875)"
      fill="#8FDDFF"
    />
    <rect
      x="106.452"
      y="87.632"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 106.452 87.632)"
      fill="#13A7FF"
    />
    <rect
      x="123.798"
      y="86.7175"
      width="9.145"
      height="9.145"
      rx="3.658"
      transform="rotate(180 123.798 86.7175)"
      fill="#8FDDFF"
    />
    <rect
      x="34.2064"
      y="70.4165"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 34.2064 70.4165)"
      fill="#13A7FF"
    />
    <rect
      x="70.7865"
      y="106.996"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 70.7865 106.996)"
      fill="#13A7FF"
    />
    <rect
      x="68.9575"
      y="123.297"
      width="9.145"
      height="9.145"
      rx="3.658"
      transform="rotate(180 68.9575 123.297)"
      fill="#8FDDFF"
    />
    <rect
      x="87.2175"
      y="123.297"
      width="9.145"
      height="9.145"
      rx="3.658"
      transform="rotate(180 87.2175 123.297)"
      fill="#8FDDFF"
    />
    <rect
      x="70.7865"
      y="33.8364"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 70.7865 33.8364)"
      fill="#13A7FF"
    />
    <rect
      x="33.292"
      y="32.9219"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 33.292 32.9219)"
      fill="#8FDDFF"
    />
    <rect
      x="14.0875"
      y="50.2975"
      width="9.145"
      height="9.145"
      rx="3.658"
      transform="rotate(180 14.0875 50.2975)"
      fill="#8FDDFF"
    />
    <rect
      x="70.7865"
      y="52.1265"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 70.7865 52.1265)"
      fill="#13A7FF"
    />
    <rect
      x="33.292"
      y="51.212"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 33.292 51.212)"
      fill="#13A7FF"
    />
    <rect
      x="51.582"
      y="106.082"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 51.582 106.082)"
      fill="#13A7FF"
    />
    <rect
      x="50.6675"
      y="123.297"
      width="9.145"
      height="9.145"
      rx="3.658"
      transform="rotate(180 50.6675 123.297)"
      fill="#8FDDFF"
    />
    <rect
      x="51.582"
      y="32.9219"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 51.582 32.9219)"
      fill="#13A7FF"
    />
    <rect
      x="88.162"
      y="32.9219"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 88.162 32.9219)"
      fill="#13A7FF"
    />
    <rect
      x="106.422"
      y="32.9219"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 106.422 32.9219)"
      fill="#8FDDFF"
    />
    <rect
      x="52.4965"
      y="52.1265"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 52.4965 52.1265)"
      fill="#080072"
    />
    <rect
      x="89.0764"
      y="52.1265"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 89.0764 52.1265)"
      fill="#080072"
    />
    <rect
      x="106.452"
      y="51.212"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 106.452 51.212)"
      fill="#13A7FF"
    />
    <rect
      x="123.798"
      y="50.2975"
      width="9.145"
      height="9.145"
      rx="3.658"
      transform="rotate(180 123.798 50.2975)"
      fill="#8FDDFF"
    />
  </svg>
</template>